<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
  [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">



        <div class="form-group col-md-4">
          <app-lfsa-input-search [path]="'Cliente'" formControlName="cliente" [placeholder]="'Cliente'"
            [label]="'Cliente'" [control]="agregarForm.get('cliente')"
            (devolverAccion)="callModal($event)" (keydown.enter)="cargarCliente($event)">
          </app-lfsa-input-search>
          <small *ngIf="agregarForm.controls['nombrecliente'].errors"
            class="text-danger">*Este campo es inválido</small>
        </div>
        <div class="form-group col-md-8">
          <app-lfsa-input [isReadOnly]="true"
            [control]="agregarForm.get('nombrecliente')" formControlName="nombrecliente"
            [label]="'Nombre cliente'" [type]="'text'" [id]="'nombrecliente'"></app-lfsa-input>
        </div>
        <div class="col-md-4 mb-2">
          <label for="material">Material</label>
          <input (change)="materialValid=false;" (keyup)="materialValid=false;" class="form-control"
            formControlName="material" id="material" type="text">
          <small *ngIf="agregarForm.controls['material'].errors"
            class="text-danger">*Este campo es inválido</small>
        </div>
        <div class="form-group col-md-8">
          <app-lfsa-input [isReadOnly]="true"
            [control]="agregarForm.get('nombrematerial')" formControlName="nombrematerial"
            [label]="'Descripción material'" [type]="'text'" [id]="'nombrematerial'"></app-lfsa-input>
        </div>

        <div class="col-md-6 mb-2">
          <label for="porcMerma">Porcentaje de Merma</label>
          <input appFourDigitDecimalNumber class="form-control" formControlName="porcMerma" id="porcMerma" type="text">
          <small *ngIf="agregarForm.controls['porcMerma'].errors"
            class="text-danger">*Este campo es inválido</small>
        </div>
        <div class="col-md-6 mb-2">
          <label for="precioUni">Precio Unitario</label>
          <input appFourDigitDecimalNumber class="form-control" formControlName="precioUni" id="precioUni" type="text">
          <small *ngIf="agregarForm.controls['precioUni'].errors"
            class="text-danger">*Este campo es inválido</small>
        </div>
        <div class="col-md-12 mb-2">
          <label for="precioUni">Unidad Precio Venta</label>
          <input class="form-control" formControlName="undPrecioVenta" id="undPrecioVenta" type="text">
          <small *ngIf="agregarForm.controls['undPrecioVenta'].errors"
            class="text-danger">*Este campo es inválido</small>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
        [formularioValido]="(agregarForm.invalid) ? true : false" [loading]="loading"
        [textBoton]="'Guardar'" class="row mt-5">
      </app-lfsa-botones-formulario>
    </form>
  </div>

  <div class="container-fluid modalAgregadosExtra" *ngIf="modalBuscarCLiente">
    <div class="modalAgregadosExtraContent">
      <div class="modalAgregadosContentHead">
        <div>Clientes {{ mostrar }}</div>
        <button type="button" aria-label="Close" class="btn-close" (click)="closeModalBuscarCLiente()"></button>
      </div>
      <div style="padding: 25px;">
        <form [formGroup]="formularioModal" novalidate class="form-group" *ngIf="!mostrar">
          <div class="row">
            <div class="form-group col-md-6">
              <app-lfsa-input [type]="'number'" [placeholder]="'Código'" [label]="'Código desde:'" [id]="'codigo1'"
                formControlName="codigo1" [control]="formularioModal.get('codigo1')"></app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
              <app-lfsa-input [type]="'number'" [placeholder]="'Código'" [label]="'Código hasta:'" [id]="'codigo2'"
                formControlName="codigo2" [control]="formularioModal.get('codigo2')"></app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
              <app-lfsa-input [type]="'number'" [placeholder]="'RUC'" [label]="'RUC desde:'" [id]="'ruc1'"
                formControlName="ruc1" [control]="formularioModal.get('ruc1')"></app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
              <app-lfsa-input [type]="'number'" [placeholder]="'RUC'" [label]="'RUC hasta:'" [id]="'ruc2'"
                formControlName="ruc2" [control]="formularioModal.get('ruc2')"></app-lfsa-input>
            </div>
            <div class="form-group col-md-6">
              <app-lfsa-input [placeholder]="'Nombre'" [label]="'Nombre:'" [id]="'nombre'" formControlName="nombre"
                [control]="formularioModal.get('nombre')"></app-lfsa-input>
            </div>

          </div>
          <button class="btn btn-outline-success" (click)="mostrarTabla()">BUSCAR</button>
        </form>
        <div *ngIf="mostrar">
          <div *ngIf="!loading">
            <button class="btn btn-outline-success" (click)="mostrarFormularioMethod()">NUEVA BUSCAR</button>
            <ag-grid-angular style="width: 100%; height: 450px;" class="ag-theme-alpine mt-3"
              [frameworkComponents]="frameworkComponentsModal" [columnDefs]="columnDefsModal"
              [rowSelection]="rowSelectionModal" [rowData]="rowDataModal" [pagination]="true">
            </ag-grid-angular>
          </div>
          <div class="containerLoader" *ngIf="loading">
            <div class="item-1"></div>
            <div class="item-2"></div>
            <div class="item-3"></div>
            <div class="item-4"></div>
            <div class="item-5"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</ng-template>
<!-- END MODAL -->